import { render, staticRenderFns } from "./blank.vue?vue&type=template&id=a2f292ea&functional=true&"
var script = {}
import style0 from "./blank.vue?vue&type=style&index=0&id=a2f292ea&prod&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports